import { memo } from 'react';
import { MerchantPayoutsTabs } from 'consts/merchantPayouts';
import Resource from 'ui/layouts/Resource';
import StatefulTabs from 'ui/widgets/StatefulTabs';
import SummaryFiles from './SummaryFiles';
import useMerchantPayouts from './useMerchantPayouts';

const MerchantPayouts = () => {
    const {
        isMerchantPayoutsLoading,
        onChangeTab,
        getTabValue
    } = useMerchantPayouts();

    return (
        <Resource
            breadcrumbsProps={{
                heading: 'Finance',
                links: [{ name: 'Monthly Summary' }],
                sx: {
                    mb: 0
                }
            }}
        >
            <StatefulTabs
                TabProps={{
                    disabled: isMerchantPayoutsLoading
                }}
                model={[
                    {
                        key: MerchantPayoutsTabs.SummaryFiles,
                        component: (
                            <SummaryFiles />
                        )
                    }
                ]}
                value={getTabValue()}
                onChange={onChangeTab}
                TabListProps={{
                    'aria-label': "merchant payouts",
                    variant: "scrollable",
                    scrollButtons: "auto",
                    sx: {
                        display: 'none'
                    },
                    TabIndicatorProps: {
                        sx: {
                            display: 'none'
                        }
                    }
                }}
                TabPanelProps={{
                    sx: {
                        p: 0
                    }
                }}
                ContainerProps={{
                    sx: {
                        width: '100%'
                    }
                }}
            />
        </Resource>
    );
};

export default memo(MerchantPayouts);
